if (!customElements.get('policy-modal')) {
  customElements.define(
    'policy-modal',
    class PolicyModal extends ModalDialog {
      constructor() {
        super();

        const urlParams = new URLSearchParams(window.location.search);
        const privacyParam = urlParams.get('privacyModal');
        if (privacyParam && this.id == 'PopupModal-PasswordPrivacy') {
          this.show(this.parentElement);
        }
      }

      hide() {
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        fetch(opener.getAttribute('data-policy-url'))
        .then((response) => response.text())
        .then((responseText) => {
        }).finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading'); 
          super.show(opener);
        });
      }
    }
  );
}
